import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadDatasetDataSources } from "../../../redux/slices/reportingdesignpageslice";
import { Field } from "@progress/kendo-react-form";
import { FormDropDownListById } from "../../../forms/form-components";
import { Button } from "@progress/kendo-react-buttons";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const WidgetSettingsFormDataSource = props => {
    const { formRenderProps, pageState, formState, onDatasetChange, onDataSourceChange, onAggregateExpressionChange, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    return (
        <Fragment>
            <div className="widget-settings-form-data-source">
                <div className="widget-settings-form-group" style={{marginTop: 8, marginBottom: 0}}>
                    <div className="header">
                       {t("reporting.design.schema")} 
                    </div>
                    <div className="content" style={{padding: "6px 20px"}}>
                        <div className="row" style={{marginBottom: 28}}>
                            <div style={{width:275}}>
                                <Field
                                    id={"datasetId"}
                                    name={"datasetId"}
                                    label={t("reporting.design.dataset")} 
                                    component={FormDropDownListById}
                                    data={pageState.datasets} dataItemKey="Id" textField="Title"  
                                    style={{marginTop:2}}
                                    disabled={pageState.processing || formState.mode != 1}
                                    onChange={onDatasetChange}
                                />
                            </div>
                        </div>
                        <div className="row" style={{marginTop: 6, marginBottom: 10}}>
                            <div style={{width:275}}>
                                <Field
                                    id={"dataSourceId"}
                                    name={"dataSourceId"}
                                    label={t("reporting.design.datasource")}
                                    component={FormDropDownListById}
                                    data={formState.dataSources} dataItemKey="Id" textField="Title"  
                                    style={{marginTop:2}}
                                    disabled={pageState.processing || formState.mode != 1}
                                    onChange={onDataSourceChange}
                                />
                            </div>
                        </div>
                        <div className="row" style={{marginBottom:0}}>
                            <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center", width:275, marginTop:0}}>
                                <Button icon="k-i-icon k-i-plus" style={{backgroundColor: currentTheme.primaryFaded, color: currentTheme.dialogTextColor}} disabled={pageState.processing || formState.mode != 1}
                                  onClick={e => {
                                    window.open("/datasources", "_blank");
                                    dispatch(loadDatasetDataSources(0, t));
                                    formRenderProps.onChange("dataSourceId", {value: 0});
                                }}>{t("reporting.design.datasource1")}</Button>
                            </div>
                        </div>
                        {
                            formState.mode == 1 && formState.dataSourceTypeId == 1 && 
                            <Fragment>
                                <div style={{fontWeight: 400, fontSize: 16, marginTop: -8, marginBottom: 12 }}>{t("reporting.design.or")}</div>
                                <div className="row" style={{marginTop: 8}}>
                                    <div style={{width:275}}>
                                        <Field
                                            id={"aggregateExpressionId"}
                                            name={"aggregateExpressionId"}
                                            label={t("reporting.design.aggexp")}
                                            component={FormDropDownListById}
                                            data={formState.aggregateExpressions} dataItemKey="Id" textField="Title"  
                                            style={{marginTop:2}}
                                            disabled={pageState.processing || formState.mode != 1}
                                            onChange={onAggregateExpressionChange}
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        }                       
                    </div>
                </div>
            </div>
            <style>
                {
                    `
                    .widget-settings-form-data-source
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex:1;
                    }
                    `
                }
            </style>
        </Fragment>
    );
};